<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/australia/eden-valley')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/australia/eden-valley/henschke')">Henschke</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/australia/barrossa-valley')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Henschke</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Anche se con molti vini del nuovo mondo l'invecchiamento non è una priorità, quando ti imbatti in un produttore che ha radici profonde nella regione e vigore del nuovo mondo, allora ciao! Hai trovato l'oro. Iconico, rispettato e fondamentale nel gettare le basi della scena enologica australiana, Henschke ha un background fantastico e un futuro infernale.
                    </div>

                    <div class="howto-title2">I meravigliosi maghi di Oz</div>
                    <div class="howto-text">
                        Una storia di 150 anni (con prezzi all'altezza) ha reso Henschke un punto di riferimento per Shiraz nel settore. Se il nome non suona australiano è perché non lo è: il fondatore Johann Henschke era un immigrato polacco che arrivò a Oz nel 1841. Vent'anni dopo, acquistò alcuni primi pacchi nella Eden Valley a Keyneton, e iniziò la storia d'amore di Henschke con la vinificazione. Oggi la tenuta è gestita dal padre di quinta e sesta generazione, quindi il team Stephen e Johann Henschke.
                    </div>

                    <div class="howto-title2">Collina della Grazia – la stella della valle</div>
                    <div class="howto-text">
                        Se Henschke fosse la domanda, Hill of Grace sarebbe la risposta. Il quinto vino australiano più costoso del 2018 (battendo di poco il Penfolds Grange di $ 2 al litro), Hill of Grace si è guadagnato uno status quasi mitico tra gli amanti del vino di tutto il mondo. Il vigneto più antico del portafoglio Henschke, Hill of Grace fu piantato nel 1860 (sebbene Henschke non lo acquistò fino al 1891). Chiamato romanticamente dopo la chiesa luterana frequentata dagli Henschke, ironia della sorte non esiste una vera collina sul vigneto Hill of Grace.
                    </div>

                    <div class="howto-title2">In avanti e oltre</div>
                    <div class="howto-text">
                        Per quanto vecchie siano le loro viti, la loro prospettiva è sicuramente di modernità. La capo viticoltrice Prue Henschke (che è subentrata nel 1987) coltiva biologicamente, guardando alla luna per bilanciare i suoi cicli di raccolta. Anche se forse non è un approccio scientifico al 100%, deve fare qualcosa di giusto poiché Hill of Grace ha ottenuto una media di punteggi aggregati di metà degli anni '90 per oltre 20 anni (per non parlare di alcuni 100 perfetti). Chiaramente, l'investibilità qui è un gioco da ragazzi. Ogni singola annata di Hill of Grace da prima del 2000 mostra un ROI senza pari, senza segni di cambiamento. Le basse rese non fanno che aggiungere fascino al vino, indipendentemente dal fatto che tu stia bevendo o invecchiando.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Henschke</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Obwohl bei vielen Weinen aus der Neuen Welt das Alter keine Priorität hat, wenn Sie auf einen Produzenten stoßen, der tief in der Region verwurzelt ist und über die Kraft der Neuen Welt verfügt, dann hallo! Du hast Gold gefunden. Henschke ist eine Ikone, respektiert und hat maßgeblich den Grundstein für die australische Weinszene gelegt. Er verfügt über einen großartigen Hintergrund und eine unglaubliche Zukunft.
                    </div>

                    <div class="howto-title2">Die wunderbaren Zauberer von Oz</div>
                    <div class="howto-text">
                        Eine 150-jährige Geschichte (mit entsprechenden Preisen) hat Henschke zu einem Maßstab für Shiraz in der Branche gemacht. Wenn der Name nicht australisch klingt, liegt das daran, dass er es nicht ist – Gründer Johann Henschke war ein polnischer Einwanderer, der 1841 in Oz ankam. Zwanzig Jahre später kaufte er einige erste Parzellen im Eden Valley in Keyneton, und Henschkes Liebesbeziehung zur Weinherstellung begann. Heute wird das Weingut in der fünften und sechsten Generation vom Vaterteam Stephen und Johann Henschke geführt.
                    </div>

                    <div class="howto-title2">Hill of Grace – der Stern des Tals</div>
                    <div class="howto-text">
                        Wenn Henschke die Frage wäre, wäre Hill of Grace die Antwort. Hill of Grace ist der fünftteuerste australische Wein im Jahr 2018 (knapp vor Penfolds Grange um 2 US-Dollar pro Liter) und hat sich unter Weinliebhabern weltweit einen fast mythischen Status erworben. Hill of Grace, der älteste Weinberg im Henschke-Portfolio, wurde 1860 gepflanzt (obwohl Henschke ihn erst 1891 erwarb). Romantisch benannt nach der lutherischen Kirche, die die Henschkes häufig besuchten, gibt es ironischerweise keinen echten Hügel auf dem Weinberg Hill of Grace.
                    </div>

                    <div class="howto-title2">Vorwärts und aufwärts</div>
                    <div class="howto-text">
                        So alt ihre Reben auch sind, ihre Einstellung ist eindeutig modern. Die leitende Winzerin Prue Henschke (die 1987 die Leitung übernahm) bewirtschaftet biologisch und orientiert sich am Mond, um ihre Erntezyklen auszugleichen. Auch wenn es sich vielleicht nicht um einen hundertprozentig wissenschaftlichen Ansatz handelt, muss sie etwas richtig gemacht haben, da Hill of Grace seit über 20 Jahren einen Gesamtdurchschnitt von mittleren 90ern erzielt (ganz zu schweigen von einigen perfekten 100ern). Offensichtlich ist die Investitionsfähigkeit hier ein Kinderspiel. Jeder einzelne Jahrgang von Hill of Grace aus der Zeit vor 2000 weist einen beispiellosen ROI auf, ohne Anzeichen einer Veränderung. Die geringen Erträge machen den Wein noch attraktiver, unabhängig davon, ob er getrunken oder im Keller gelagert wird.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Henschke</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Bien que pour de nombreux vins du nouveau monde, l'âge ne soit pas une priorité, lorsque vous rencontrez un producteur qui a des racines profondes dans la région et une vigueur du nouveau monde, alors bonjour ! Vous avez trouvé de l'or. Emblématique, respecté et fondamental pour jeter les bases de la scène viticole australienne, Henschke a un sacré passé et un sacré avenir.
                    </div>

                    <div class="howto-title2">Le(s) merveilleux magicien(s) d'Oz</div>
                    <div class="howto-text">
                        Une histoire de 150 ans (avec des prix correspondants) a fait de Henschke une référence pour Shiraz dans l'industrie. Si le nom ne sonne pas australien, c'est parce qu'il ne l'est pas - le fondateur Johann Henschke était un immigrant polonais arrivé à Oz en 1841. Vingt ans plus tard, il a acheté quelques parcelles initiales dans la vallée d'Eden à Keyneton, et l'histoire d'amour de Henschke avec la vinification a commencé. Aujourd'hui, le domaine est dirigé par un père de cinquième et sixième génération, donc l'équipe Stephen et Johann Henschke.
                    </div>

                    <div class="howto-title2">Hill of Grace – l'étoile de la vallée</div>
                    <div class="howto-text">
                        Si Henschke était la question, Hill of Grace serait la réponse. Le 5e vin australien le plus cher en 2018 (battant de peu Penfolds Grange de 2 $ le litre), Hill of Grace a acquis un statut presque mythique parmi les amateurs de vin du monde entier. Le plus ancien vignoble du portefeuille Henschke, Hill of Grace a été planté dans les années 1860 (bien que Henschke ne l'ait acquis qu'en 1891). Nommé d'après l'église luthérienne que les Henschke fréquentaient, ironiquement, il n'y a pas de véritable vignoble Hill on the Hill of Grace.
                    </div>

                    <div class="howto-title2">En avant et vers le haut</div>
                    <div class="howto-text">
                        Quelle que soit l'ancienneté de leurs vignes, leur regard est résolument tourné vers la modernité. La viticultrice en chef Prue Henschke (qui a pris la relève en 1987) cultive en agriculture biologique, regardant vers la lune pour équilibrer ses cycles de récolte. Bien qu'il ne s'agisse peut-être pas d'une approche 100% scientifique, elle doit faire quelque chose de bien, car Hill of Grace a obtenu des scores moyens cumulés du milieu des années 90 pendant plus de 20 ans (sans parler de quelques 100 parfaits). De toute évidence, l'investabilité ici est une évidence. Chaque millésime de Hill of Grace d'avant 2000 montre un retour sur investissement inégalé, sans aucun signe de changement. Les faibles rendements ne font qu'ajouter à l'attrait du vin, que vous le buviez ou le mettiez en cave.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Henschke</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Although with many new world wines age is not a priority, when you come across a producer that has deep roots in the region and new world vigour, then hello! You've struck gold. Iconic, respected and fundamental in laying the foundation of the Australian wine scene, Henschke has one heck of a background, and one hell of a future.
                    </div>

                    <div class="howto-title2">The wonderful wizard(s) of Oz</div>
                    <div class="howto-text">
                        A 150-year history (with prices to match) has made Henschke a benchmark for Shiraz in the industry. If the name doesn’t sound Australian that’s because it isn’t – founder Johann Henschke was a Polish immigrant who arrived in Oz in 1841. Twenty years later, he purchased some initial parcels in the Eden Valley in Keyneton, and Henschke’s love affair with winemaking began. Today the estate is run by fifth and sixth generation father so team Stephen and Johann Henschke.
                    </div>

                    <div class="howto-title2">Hill of Grace – the star of the valley</div>
                    <div class="howto-text">
                        If Henschke was the question, Hill of Grace would be the answer. The 5th most expensive Australian wine in 2018 (narrowly beating Penfolds Grange by $2 a litre), Hill of Grace has earnt an almost mythical status among wine lovers worldwide. The oldest vineyard in the Henschke portfolio, Hill of Grace was planted in the 1860 (although Henschke didn’t acquire it until in 1891). Romantically named after the Lutheran Church that the Henschkes frequented, ironically there is no actual Hill on the Hill of Grace vineyard.
                    </div>

                    <div class="howto-title2">Onwards and upwards</div>
                    <div class="howto-text">
                        However old their vines are, their outlook is most definitely one of modernity. Head viticulturist Prue Henschke (who took over in 1987) farms organically, looking to the moon to balance her harvesting cycles. Whilst perhaps not a 100% scientific approach, she must be doing something right as Hill of Grace has averaged aggregate scores of mid-90s for over 20 years (not to mention quite a few perfect 100s). Clearly, investability here is a no brainer. Every single vintage of Hill of Grace from pre-2000 shows unparalleled ROI, with no signs of change. The low yields only add the wine’s appeal, regardless of whether you are drinking or cellaring.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Henschke",
        data () {
            return {
                select: { report: 'Henschke', src: '/wine-guide/australia/eden-valley/henschke' },
                items: [
                    { report: 'Henschke', src: '/wine-guide/australia/eden-valley/henschke' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Henschke | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Indulge in the rich history and flavors of Henschke Wines. A premium wine producer in South Australia, Henschke is known for its expertly crafted Shiraz, Cabernet Sauvignon, and other varietals that showcase the unique terroirs and rich winemaking heritage of the Barossa Valley and beyond. Experience the essence of Australia\'s winemaking tradition with every sip from Henschke.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover,
    .wine-guide-country.active {
      border-color: #024E7B;
      background: #E5EDF2;
    }
</style>
